<template>
  <el-dialog class="dialog-edit-daily-stat" :title="title" :visible.sync="visible" width="400px">
    <el-form ref="form" label-width="80px" label-position="left" :model="formData" :rules="rules" inline>
      <el-form-item v-for="(item, i) in formItems" :key="i" :label="item.label" :prop="item.key" size="medium">
        <el-date-picker v-if="item.type === 'date'" v-model="formData[item.key]" type="date" size="small" placeholder="请选择日期"
        value-format="yyyy-MM-dd"></el-date-picker>
        <el-input-number v-else v-model="formData[item.key]" size="small" :min="0" :placeholder="`请输入${ item.label }数量`"></el-input-number>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close" size="small">取 消</el-button>
      <el-button type="primary" @click="sure" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
const formItems = [
  { type: 'date', label: '日期', key: 'date' },
  { type: 'number', label: '评论更新', key: 'commentCount' },
  { type: 'number', label: '帖子更新', key: 'postCount' },
  { type: 'number', label: '视频更新', key: 'videoCount' },
]
export default {
  emit: ['close'],
  data() {
    return {
      visible: false,
      formItems,
      formData: {},
      rules: {
        date: [{ required: true, message: '请选择日期' }],
        commentCount: [{ required: true, message: '请输入评论更新数量' }],
        postCount: [{ required: true, message: '请输入帖子更新数量' }],
        videoCount: [{ required: true, message: '请输入视频更新数量' }],
      },
      row: null
    };
  },
  watch: {
    row: {
      handler(val) {
        if (val) {
          Object.assign(this.formData, val)
        } else {
          /// 新增初始化form data
          this.init()
        }
      }
    }
  },
  computed: {
    isEdit() {
      return !!this.row
    },
    title() {
      return this.isEdit ? '编辑统计' : '新增统计'
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      /// 初始化form data
      this.formData = {
        date: '',
        commentCount: null,
        postCount: null,
        videoCount: null
      }
    },
    close() {
      this.visible = false
    },
    open(row) {
      this.row = row
      this.visible = true
    },
    sure() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('sure', { isEdit: this.isEdit, data: this.formData })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.dialog-edit-daily-stat {
  
}
</style>
